





import { Mixins, Component } from 'vue-property-decorator';
import AccountSettings from '@/mixins/accountSettings.mixin';
import { getInstance } from '..';

@Component({
})
export default class CallbackComponent extends Mixins(AccountSettings) {
  beforeMount() {
    const authService = getInstance();
    this.$router.push({ path: '/login', query: { redirect: authService.redirectTo } });
  }
};
